import React from 'react';
import { Stepper, Step, StepButton, StepContent, Button, Box, StepConnector } from '@mui/material';
import { withStyles } from 'tss-react/mui';

const styles = theme => ({
    stepper: {
        padding: theme.spacing(1),
        paddingRight: 0
    },
    stepButton: {
        paddingLeft: 0,
        paddingRight: 0,
    },
    changeStepButton: {
        margin: theme.spacing(1)
    },
    connector: {
        paddingBottom: theme.spacing(1),
        minHeight: 0,
        height: 0,
    },
    connectorLine: {
        border: 'none',
    }
});

class SimpleStepper extends React.Component {
    state = {
        activeStep: 0
    }

    render() {
        const { classes, steps, onStepChangeVerification, onActiveStepChange, ...other } = this.props;
        const { activeStep } = this.state;

        return (
            <Box>
                <Button
                    variant='text'
                    onClick={(event) => this.handleActiveStepChange(event, activeStep > 0 ? activeStep - 1 : 0)}
                    disabled={activeStep < 1}
                    className={classes.changeStepButton}
                >
                    Back
                </Button>
                <Button
                    variant='text'
                    onClick={(event) => this.handleActiveStepChange(event, activeStep < steps.length - 1  ? activeStep + 1 : steps.length - 1)}
                    disabled={activeStep >= steps.length - 1}
                    className={classes.changeStepButton}
                >
                    Next
                </Button>
                <Stepper
                    {...other}
                    activeStep={activeStep}
                    className={classes.stepper}
                    connector={
                        <StepConnector 
                            className={classes.connector} 
                            classes={{
                                line: classes.connectorLine
                            }}
                        />
                    }
                >
                    {this.steps()}
                </Stepper>
            </Box>
        );
    }

    componentDidMount() {
        const { startStep } = this.props;

        if (startStep)
            this.setState({activeStep: startStep});
    }

    handleActiveStepChange = (event, index) => {
        const { onStepChangeVerification, onActiveStepChange } = this.props;
        const stepChangeAllowed = Boolean(onStepChangeVerification) ? onStepChangeVerification() : true;

        if (!stepChangeAllowed) {
            event.preventDefault();
            event.stopPropagation();
            return;
        }

        if (typeof onActiveStepChange === "function")
            onActiveStepChange();

        this.setState({activeStep: index});
    }

    steps = () => {
        const { classes, steps } = this.props;

        return steps.map((step, index) =>
            <Step key={step.label}>
                <StepButton
                    onClick={(event) => this.handleActiveStepChange(event, index)}
                    className={classes.stepButton}
                    focusRipple
                >
                    {step.label}
                </StepButton>
                <StepContent style={{padding: 0}}>
                    {step.content}
                </StepContent>
            </Step>
        );
    }
}

export default withStyles(SimpleStepper, styles);